import React from 'react';
import '../styles/SocialPlatforms.css';

const SocialPlatforms = () => {
  return (
    <section className="social-platforms">
      <div className="container">
        <div className="platforms-content">
          <div className="platforms-section">
            <h3>Follow us</h3>
            <div className="social-icons">
              <a href="https://www.facebook.com/metroblue" className="social-link">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="https://www.twitter.com/metroblueL/" className="social-link">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://www.linkedin.com/company/metroblue" className="social-link">
                <i className="fab fa-linkedin"></i>
              </a>
            </div>
          </div>
          
          <div className="platforms-section">
            <h3>Platforms</h3>
            <div className="platform-icons">
              <i className="fab fa-apple"></i>
              <i className="fab fa-windows"></i>
              <i className="fab fa-android"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialPlatforms;